import { render } from "./LeadCapture.vue?vue&type=template&id=31ef10af&scoped=true"
import script from "./LeadCapture.vue?vue&type=script&lang=js"
export * from "./LeadCapture.vue?vue&type=script&lang=js"

import "./LeadCapture.vue?vue&type=style&index=0&id=31ef10af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ef10af"]])

export default __exports__